import React from "react";

export default function RepairRecycleModal({ repairRecyclingInfo }) {
  if (!repairRecyclingInfo) return null;
 
  const Stars = ({ value = 8.6, max = 10 }) => {
    const fullStars = Math.floor(value);
    const hasHalf = value - fullStars >= 0.5 && fullStars < max;

    const stars = [];
    for (let i = 0; i < max; i++) {
      if (i < fullStars) {
        stars.push(<span key={i} style={{ color: "#3b82f6", fontSize: 16 }}>★</span>);
      } else if (i === fullStars && hasHalf) { 
        stars.push(<span key={i} style={{ color: "#93c5fd", fontSize: 16 }}>★</span>); 
      } else {
        stars.push(<span key={i} style={{ color: "#e2e8f0", fontSize: 16 }}>★</span>);
      }
    }
    return <div style={{ display: "flex", gap: "2px", alignItems: "center" }}>{stars}</div>;
  };

  const formatFloat = (value, decimals = 2) => {
    if (typeof value === "number") {
      return value.toFixed(decimals);
    }
    if (typeof value === "string") {
      const num = parseFloat(value);
      return isNaN(num) ? value : num.toFixed(decimals);
    }
    return value || "—";
  };

  return ( 
    <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "4px 0" }}>
       
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px dashed #e2e8f0", paddingBottom: "8px" }}>
        <span style={{ fontSize: "13px", color: "#64748b", fontWeight: 600 }}>Repairability Score</span>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Stars value={repairRecyclingInfo?.recyclability?.recycleScore} />
          <span style={{ fontSize: "13px", fontWeight: 700, color: "#0f172a" }}>
            {formatFloat(repairRecyclingInfo?.recyclability?.recycleScore, 2)}
          </span>
        </div>
      </div>
 
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px dashed #e2e8f0", paddingBottom: "8px" }}>
        <span style={{ fontSize: "13px", color: "#64748b", fontWeight: 600 }}>Spare Parts Availability</span>
        <span style={{ fontSize: "13px", fontWeight: 700, color: "#0f172a" }}>
          {repairRecyclingInfo?.recyclability?.sparePartsAvailability || "—"}
        </span>
      </div>
 
      {repairRecyclingInfo?.authorizedRepairCenters?.length > 0 && (
        <div style={{ marginTop: "4px" }}>
          <div style={{ fontSize: "13px", fontWeight: 700, color: "#0f172a", marginBottom: "8px" }}>
            Authorized Repair Centers
          </div>
          {repairRecyclingInfo.authorizedRepairCenters.map((center, idx) => (
            <div key={idx} style={{ display: "flex", gap: "8px", alignItems: "flex-start", marginBottom: "8px", fontSize: "13px", color: "#334155" }}>
              <span style={{ fontSize: "14px", marginTop: "2px" }}>📍</span>
              <span style={{ fontWeight: 500, lineHeight: 1.4 }}>
                {center.repairCenters && `${center.repairCenters} - `}
                {center.location}
              </span>
            </div>
          ))}
        </div>
      )}
 
      {repairRecyclingInfo?.materialRecyclability?.length > 0 && (
        <div style={{ marginTop: "4px" }}>
          <div style={{ fontSize: "13px", fontWeight: 700, color: "#0f172a", marginBottom: "8px" }}>
            Material Recyclability
          </div>
          {repairRecyclingInfo.materialRecyclability.map((item, idx) => (
            <div key={idx} style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "6px", fontSize: "13px", color: "#334155" }}>
              <span style={{ fontSize: "14px" }}>♻️</span>
              <span style={{ fontWeight: 500 }}>
                {item.rmMaterial}: <span style={{ color: "#0f172a", fontWeight: 600 }}>{item.resourceType}</span>
              </span>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}